/**
 * Modal para Encuesta de Clima Laboral 2026
 * Este componente bloquea el acceso al sistema hasta que el usuario acepte participar
 */
import React, { useState } from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import './EncuestaClimaModal.css';

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:4005' : '');

const EncuestaClimaModal = ({ show, onAccepted, userData }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleAceptar = async () => {
    if (!userData) {
      setError('No se pudo obtener la información del usuario');
      return;
    }

    try {
      setSubmitting(true);
      setError(null);

      const token = localStorage.getItem('token');
      
      // Registrar la aceptación en la BD
      await axios.post(
        `${API_URL}/api/Extra/encuesta-clima`,
        {
          CdEmpleado: userData.CdEmpleado || userData.Legajo,
          NmEmpleado: userData.Nombre,
          Accion: 'aceptar',
          Anio: 2026
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      console.log('✅ Encuesta registrada exitosamente');
      
      // Redirigir al formulario de Google Forms
      window.open('https://forms.gle/hWayCDULo6kL1pz57', '_blank');
      
      // Notificar que se aceptó correctamente (para cerrar el modal y permitir acceso)
      if (onAccepted) {
        onAccepted();
      }

    } catch (err) {
      console.error('❌ Error registrando encuesta:', err);
      setError(err.response?.data?.error || 'Error al registrar la aceptación');
      setSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
      className="encuesta-clima-modal"
    >
      <Modal.Header className="bg-info text-white">
        <Modal.Title>
          📊 ENCUESTA DE CLIMA 2026
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant="info" className="mb-4">
          <h5>¡Tu opinión es importante para nosotros! 🎯</h5>
          <p className="mb-3 mt-3">
            Estamos realizando la Encuesta de Clima Laboral 2026 para conocer tu experiencia 
            y mejorar continuamente nuestro ambiente de trabajo.
          </p>
          <p className="mb-0">
            <strong>Al presionar "Aceptar":</strong>
          </p>
          <ul className="mt-2 mb-0">
            <li>Serás redirigido al formulario de encuesta</li>
            <li>Tus respuestas son confidenciales y anónimas</li>
            <li>Te tomará aproximadamente 5 minutos completarla</li>
          </ul>
        </Alert>

        {error && (
          <Alert variant="danger" className="mb-3">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        <div className="text-center py-4">
          <Button
            variant="info"
            size="lg"
            onClick={handleAceptar}
            disabled={submitting}
            className="px-5 py-3"
            style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
          >
            {submitting ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Procesando...
              </>
            ) : (
              '✅ Aceptar y Continuar'
            )}
          </Button>
        </div>

        <div className="text-center text-muted mt-3">
          <small>
            Gracias por tu colaboración en la mejora continua de nuestro ambiente laboral.
          </small>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EncuestaClimaModal;
